import { AfterViewInit, Component, OnInit } from '@angular/core';
import { EmployerService } from '../../services/employer.service';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'epay-employer-register',
  templateUrl: './employer.register.component.html',
})
export class EMPRegisterComponent implements OnInit, AfterViewInit {
  pagetitle = 'Employer: Create Account';
  baseurl = '';
  termsContent = '';
  loginHelp = '';
  canCreateNewEmployer: boolean;
  useEmailForLogin = CommonSettings.UseEmailForLogin;
  allowEINSearch = CommonSettings.AllowEINSearch;

  constructor(private employerService: EmployerService) {
    this.baseurl = CommonSettings.BaseApi;
    this.canCreateNewEmployer = CommonSettings.CanCreateNewEmployer;
  }
  ngAfterViewInit(): void {
    this.horizontalStepperRoleFix()
  }

  ngOnInit() {
    this.employerService.getEmployerTerms().subscribe((result: any) => {
      this.termsContent = result;
    });
    this.employerService.getLoginHelp().subscribe((result: any) => {
      this.loginHelp = result;
    });
  }

    horizontalStepperRoleFix() {
   document.getElementsByClassName('mat-horizontal-stepper-header-container')[0].setAttribute('role', 'tablist');
   document.getElementsByClassName('mat-stepper-horizontal')[0].removeAttribute('role');
  }
}
